<script lang="ts" setup>
import type { RouteLocationMatched } from 'vue-router'
import { useRoute } from 'vue-router'
import { commonStore } from '@/stores/common'
withDefaults(defineProps<{
  breadcrumbAppend?: string, // 详情页需要动态设置产品名称或者设备名称
}>(), {
  breadcrumbAppend: '',
})
const common = commonStore()
const route = useRoute()
const matched:RouteLocationMatched[] = route.matched! // 匹配的路径包含当前路径，以及路由的parent
const current = matched[matched.length - 1]
const path = current.meta?.resourceUrl || current.path // 详情页，需要配置其列表页入口
const breadcrumbList = []
const permissionList = common.permissionList || []
for (let i = 0; i < permissionList.length; i++) {
  const permission = permissionList[i]
  const { resourceUrl, children } = permission
  const childItem = (children || []).find(child => child.resourceUrl === path)
  if (childItem) {
    breadcrumbList.push(permission, childItem)
    break
  } else if (resourceUrl === path && (!children || !children?.length)) { // 只有一级导航的时候
    breadcrumbList.push(permission)
    break
  }
}
</script>

<template>
  <div v-show="breadcrumbList.length" class="jy-breadcrumb">
    <div>当前位置：</div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.path">
        {{ item.resourceName }}
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="breadcrumbAppend">
        {{ breadcrumbAppend }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<style lang="scss">
  .jy-breadcrumb {
    height: 40px;
    line-height: 40px;
    color: #999;

    div {
      display: inline-block;
      vertical-align: top;
    }

    .el-breadcrumb__item {
      display: inline-block;
      line-height: 40px;

      .el-breadcrumb__inner {
        color: #999;
      }

      &:last-child {
        .el-breadcrumb__inner {
          color: #333;
        }
      }
    }
  }
</style>
